const musicLinksIT = {
    "view": {
        "table": {
            "title": "La tua lista di link musicali",
            "column": {
                "releaseName": "Nome del Rilascio",
                "artists": "Artisti",
                "owner": "Proprietario",
                "created": "Creato",
                "musicLink": "Link Musicale",
                "action": "Azione"
            },
            "button": {
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "message": {
                "linkCopied": "Link copiato negli appunti!"
            }
        },
        "modal": {
            "edit": {
                "header": "Modificare {{musicLinkName}}?",
                "body": "Sei sicuro di voler modificare questo link musicale?"
            },
            "delete": {
                "header": "Eliminare {{musicLinkName}}?",
                "body": "Sei sicuro di voler eliminare questo link musicale?"
            }
        },
        "message": {
            "success": "Il link musicale è stato rimosso!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
            "mlAllowanceSpent": "Hai esaurito la tua quota di link musicali. Per creare più link musicali, aggiorna il tuo account o contatta il nostro team di supporto.",
            "subscriptionFeatureUnavailable": "Il tuo piano di abbonamento attuale non supporta questa funzione. Per favore <1>aggiorna</1> il tuo piano di abbonamento per usufruire di questa funzione.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Per favore <1>riprendi</1> il tuo abbonamento per usufruire di questa funzione.",
            "moduleAccessRestricted": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        }
    },
    "add": {
        "title": "Aggiungi Link Musicale",
        "form": {
            "label": {
                "source": "Fonte",
                "subUser": "Sotto-Utente",
                "release": "Rilascio",
                "artwork": "Opera d'Arte",
                "releaseName": "Nome del Rilascio",
                "upcEan": "UPC/EAN",
                "artistName": "Nome dell'Artista",
                "urlPart1": "Parte Url 1",
                "urlPart2": "Parte Url 2",
                "musicLinkUrl": "Il tuo URL del link musicale è",
                "searchBy": "Cerca Per",
                "upcNumber": "Numero UPC",
                "storeReleaseUrl": "URL del Rilascio del Negozio",
                "colorCustomisation": "Personalizzazione Colore",
                "premadeColors": "Colori Predefiniti",
                "customColors": "Colori Personalizzati",
                "buttonStyle": "Stile del Pulsante",
                "headerBackground": "Sfondo dell'Intestazione",
                "singleColor": "Colore Singolo",
                "gradient": "Gradiente",
                "playerControlsColor": "Colore dei Controlli del Lettore",
                "titleColor": "Colore del Titolo",
                "descriptionColor": "Colore della Descrizione",
                "buttonColor": "Colore del Pulsante",
                "buttonHoverColor": "Colore al Passaggio del Mouse sul Pulsante",
                "buttonTextColor": "Colore del Testo del Pulsante"
            },
            "placeholder": {
                "subUser": "Seleziona Sotto-utente...",
                "release": "Seleziona Rilascio",
                "releaseUpc": "Inserisci Numero UPC/EAN del Rilascio es. 5055964352523",
                "releaseStoreUrl": "Inserisci URL del Rilascio del Negozio es. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn o www.deezer.com/en/album/413370367",
                "urlPart1": "Seleziona Parte Url 1"
            },
            "help_text": {
                "subUser": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un link musicale per uno dei tuoi Sotto-utenti, altrimenti lascia non selezionato.",
                "release": "Nota: Puoi selezionare solo rilasci che sono <strong>Distribuiti.</strong>",
                "releaseUpc": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un rilascio che è già su Spotify o Deezer.",
                "releaseStoreUrl": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un rilascio che è già su Spotify o Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Rilascio di Link Musicale Esistente",
                    "externalRelease": "Rilascio Esterno"
                },
                "buttonStyle": {
                    "outlined": "Contornato",
                    "filled": "Riempito"
                }
            },
            "button": {
                "reset": "Reimposta",
                "createNew": "Creare Nuovo?",
                "submit": "Invia"
            },
            "validation": {
                "formInvalid": "Il modulo non può essere inviato! Per favore compila tutti i campi e controlla gli errori!",
                "storeUrlRequired": "È richiesto l'URL di {{store}}",
                "storeUrlValid": "Per favore aggiungi un URL valido di {{store}}."
            }
        },
        "message": {
            "success": "Il link musicale è stato aggiunto!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
            "fetchingReleaseDetails": "Recupero dei Dettagli del Rilascio..."
        }
    },
    "update": {
        "title": "Modifica Link Musicale",
        "form": {
            "label": {
                "source": "Fonte",
                "release": "Rilascio",
                "artwork": "Opera d'Arte",
                "releaseName": "Nome del Rilascio",
                "upcEan": "UPC/EAN",
                "artistName": "Nome dell'Artista",
                "urlPart1": "Parte Url 1",
                "urlPart2": "Parte Url 2",
                "musicLinkUrl": "Il tuo URL del link musicale è",
                "searchBy": "Cerca Per",
                "upcNumber": "Numero UPC",
                "storeReleaseUrl": "URL del Rilascio del Negozio",
                "colorCustomisation": "Personalizzazione Colore",
                "premadeColors": "Colori Predefiniti",
                "customColors": "Colori Personalizzati",
                "buttonStyle": "Stile del Pulsante",
                "headerBackground": "Sfondo dell'Intestazione",
                "singleColor": "Colore Singolo",
                "gradient": "Gradiente",
                "playerControlsColor": "Colore dei Controlli del Lettore",
                "titleColor": "Colore del Titolo",
                "descriptionColor": "Colore della Descrizione",
                "buttonColor": "Colore del Pulsante",
                "buttonHoverColor": "Colore al Passaggio del Mouse sul Pulsante",
                "buttonTextColor": "Colore del Testo del Pulsante"
            },
            "placeholder": {
                "release": "Seleziona Rilascio",
                "releaseUpc": "Inserisci Numero UPC/EAN del Rilascio es. 5055964352523",
                "releaseStoreUrl": "Inserisci URL del Rilascio del Negozio es. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn o www.deezer.com/en/album/413370367",
                "urlPart1": "Seleziona Parte Url 1"
            },
            "help_text": {
                "release": "Nota: Puoi selezionare solo rilasci che sono <strong>Distribuiti.</strong>",
                "releaseUpc": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un rilascio che è già su Spotify o Deezer.",
                "releaseStoreUrl": "Nota: Usa questo menu a tendina solo se vuoi aggiungere un rilascio che è già su Spotify o Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Rilascio di Link Musicale Esistente",
                    "externalRelease": "Rilascio Esterno"
                },
                "buttonStyle": {
                    "outlined": "Contornato",
                    "filled": "Riempito"
                }
            },
            "button": {
                "reset": "Reimposta",
                "createNew": "Creare Nuovo?",
                "submit": "Invia"
            },
            "validation": {
                "formInvalid": "Il modulo non può essere inviato! Per favore compila tutti i campi e controlla gli errori!",
                "storeUrlRequired": "È richiesto l'URL di {{store}}",
                "storeUrlValid": "Per favore aggiungi un URL valido di {{store}}."
            }
        },
        "message": {
            "success": "Il link musicale è stato aggiornato!",
            "error": "Qualcosa è andato storto! Per favore aggiorna la pagina e riprova!",
            "fetchingReleaseDetails": "Recupero dei Dettagli del Rilascio..."
        }
    },
    "storeLinksRow": {
        "title": "Link del Negozio",
        "label": {
            "store": "Negozio",
            "link": "Link"
        },
        "button": {
            "remove": "Rimuovi"
        },
        "model": {
            "addStore": {
                "header": "Aggiungi Negozio",
                "body": "Per favore scegli il negozio desiderato dalla lista qui sotto:",
                "option": {
                    "mainStores": "Negozi Principali",
                    "otherStores": "Altri Negozi"
                },
                "button": {
                    "add": "Aggiungi Negozio",
                    "cancel": "Annulla"
                }
            }
        }
    },
    "previewFilesRow": {
        "title": "Anteprima File",
        "label": {
            "preview": "Anteprima",
            "artistName": "Nome dell'Artista",
            "trackName": "Nome del Brano"
        },
        "audioNotSupported": "Il tuo browser non supporta l'elemento audio."
    },
    "landingPagePreview": {
        "label": {
            "chooseMusicService": "Scegli il Servizio Musicale",
            "track": "Brano",
            "artist": "Artista",
            "time": "Tempo",
            "others": "Altri"
        },
        "button": {
            "play": "Riproduci"
        }
    },
    "viewStats": {
        "label": {
            "fetchingStats": "Recupero Statistiche per il Link Musicale"
        },
        "topServices": {
            "title": "Servizi Principali",
            "subtitle": "CLICK THROUGH PER SERVIZIO",
            "table": {
                "column": {
                    "store": "Negozio",
                    "noOfVisits": "Visite Totali",
                    "noOfVisitsPct": "Visite Totali %"
                },
                "label": {
                    "otherStores": "Altri Negozi"
                }
            }
        },
        "topTracks": {
            "title": "Brani Principali",
            "subtitle": "CLICK THROUGH PER BRANO",
            "table": {
                "column": {
                    "trackName": "Nome del Brano",
                    "artistName": "Nome dell'Artista",
                    "noOfPlays": "Numero di Riproduzioni",
                    "noOfPlaysPct": "Numero di Riproduzioni %"
                }
            }
        },
        "topTerritories": {
            "title": "Territori Principali",
            "subtitle": "CLICK THROUGH PER TERRITORIO",
            "table": {
                "column": {
                    "territory": "Territorio",
                    "noOfViews": "Numero di Visualizzazioni",
                    "noOfViewsPct": "Numero di Visualizzazioni %"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Tipi di Dispositivi Principali",
            "subtitle": "CLICK THROUGH PER TIPO DI DISPOSITIVO"
        },
        "topOperatingSystems": {
            "title": "Sistemi Operativi Principali",
            "subtitle": "CLICK THROUGH PER OS",
            "chart": {
                "label": {
                    "noOfViews": "Numero di Visualizzazioni : ",
                    "operatingSystems": "Sistema Operativo"
                }
            }
        },
        "topBrowsers": {
            "title": "Browser Principali",
            "subtitle": "CLICK THROUGH PER BROWSER",
            "table": {
                "column": {
                    "browser": "Browser",
                    "noOfViewsPct": "Numero di Visualizzazioni (%)"
                }
            }
        }
    }
};

export default musicLinksIT;